export const GET_WELCOME = "GET_WELCOME";
export const COGNITO_LOGIN = "COGNITO_LOGIN";
export const SIGN_IN = "SIGN_IN";
export const SIGN_OUT = "SIGN_OUT";
export const REOPEN_SESSION = "REOPEN_SESSION";
export const GET_REMINDERS = "GET_REMINDERS";
export const GET_TRAINING = "GET_TRAINING";
export const GET_VC = "GET_VC";
export const GET_SETUP_INFO = "GET_SETUP_INFO";
export const EDIT_SETUP_INFO = "EDIT_SETUP_INFO";
export const ADD_VC = "ADD_VC";
export const DELETE_VC = "DELETE_VC";
